export const ATTACHMENT_TYPE_ID = '@type';
export const MENTIONS = 'MENTIONS';
export const FILES = 'FILES';